import {
  For,
  createEffect,
  createMemo,
  lazy,
  onCleanup,
  onMount,
} from "solid-js";

import Buoy from "@/components/Base/Buoy/Buoy.tsx";
import DialogSettingCenter from "@/components/Dialogs/DialogCenter";
import { getIndexComponentLists } from "@/hooks/useConfig";
import { usePageScrollDetection } from "@/hooks/usePageScrollDetection";
import { getHomePopups } from "@/hooks/usePopup";
import { isMobile } from "@/lib/isMobile";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { getAdtype } from "@/lib/utils";
import {
  FooterComponents,
  getRenderedStatus,
  updateRenderedMap,
} from "@/stores/configStore";
import { CompType } from "@/types/compontent/base/baseEnum";
import { CompontentFactory } from "@/types/compontent/compontentFactory";
import { ComponentInfo } from "@/types/swagger/front";

// 预加载关键组件
const preloadComponents = () => {
  const components = ["banner", "game_list", "guess_you_like", "foot_info"];
  components.forEach((type) => {
    import(`@/components/PC/Components/${type}/index.tsx`);
  });
  import("@/pages/pc/gamedetail");
};

function RenderIndexComponent({ item }: { item: ComponentInfo }) {
  // 使用 CompontentFactory 创建组件实例
  const factory = CompontentFactory.getInstance();
  const component = factory.createComponent({
    ...item,
    type: item.type as CompType,
  });
  // 组件卸载时清理
  onCleanup(() => {
    factory.destroyComponent(component);
  });

  // 动态导入组件
  const DynamicComponent = lazy(
    () => import(`@/components/PC/Components/${item.type}/index.tsx`),
  );

  const placeHeight = createMemo(() => {
    return getRenderedStatus(item.key)
      ? "unset"
      : isMobile()
        ? item.height
        : item.pc_height;
  });
  if (!item.delay) {
    setTimeout(() => {
      updateRenderedMap(item.key, true);
    }, 100);
  }
  return (
    <div style={{ height: placeHeight() }}>
      <DynamicComponent {...component} />
    </div>
  );
}
export default function PCHomePage() {
  // 预加载组件
  preloadComponents();
  onMount(() => {
    usePageScrollDetection("home_page_scroll", 0.5);
    // 清理之前的弹窗队列，确保弹窗状态正确重置
    DialogSettingCenter.clearQueue();
    sdkManager.tdReportEvent("home_page_visit", {
      ad_type: getAdtype(),
    });
    sdkManager.setStartTime("home_page", Math.floor(Date.now() / 1000));

    const tiemout = setTimeout(() => {
      getHomePopups();
    }, 500);

    onCleanup(() => {
      sdkManager.setEndTime("home_page", Math.floor(Date.now() / 1000));
      sdkManager.tdReportEvent("home_page_stay_time", {
        page_view_stay_time: sdkManager.getTimeGap("home_page"),
      });
      clearTimeout(tiemout);
    });
  });

  const newList = createMemo(() => {
    const baseList = getIndexComponentLists().filter((item) => {
      return !FooterComponents.includes(item.type);
    });
    return baseList;
  });

  const renderedList = createMemo(() => newList());

  return (
    <div class="flex flex-col pt-[24px]">
      <For each={renderedList()} fallback={<div></div>}>
        {(item, index) => {
          return (
            <div
              class={
                item.type !== "banner" && item.type !== "carousel"
                  ? `wrap ${index() === renderedList().length - 1 ? "!mb-[40px]" : "!mb-[24px]"}`
                  : item.type == "banner"
                    ? "!mb-[12px]"
                    : ""
              }
            >
              <RenderIndexComponent item={item as ComponentInfo} />
            </div>
          );
        }}
      </For>

      <Buoy />
    </div>
  );
}
